/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavParsePreview
 */
export interface InputUavParsePreview {
    /**
     * 
     * @type {string}
     * @memberof InputUavParsePreview
     */
    rawMessage: string;
    /**
     * ReceivedAt — «момент подачі» заявки (RFC3339): від нього пайплайн бере рік для дат без
     * року та today для заявок без дати. Порожньо -> зараз. Потрібно, щоб відтворити старий
     * проблемний кейс у тих самих умовах, у яких його бачив воркер.
     * @type {string}
     * @memberof InputUavParsePreview
     */
    receivedAt?: string;
}

/**
 * Check if a given object implements the InputUavParsePreview interface.
 */
export function instanceOfInputUavParsePreview(value: object): boolean {
    if (!('rawMessage' in value)) return false;
    return true;
}

export function InputUavParsePreviewFromJSON(json: any): InputUavParsePreview {
    return InputUavParsePreviewFromJSONTyped(json, false);
}

export function InputUavParsePreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavParsePreview {
    if (json == null) {
        return json;
    }
    return {
        
        'rawMessage': json['rawMessage'],
        'receivedAt': json['receivedAt'] == null ? undefined : json['receivedAt'],
    };
}

export function InputUavParsePreviewToJSON(value?: InputUavParsePreview | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rawMessage': value['rawMessage'],
        'receivedAt': value['receivedAt'],
    };
}

